var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';
import { baseColors } from '../../Themes/colors';
var CardRoot = styled(Stack)(function () { return ({
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: baseColors.fullWhite,
    border: "1px solid ".concat(baseColors.greyPreset[40]),
    borderRadius: 8,
    padding: 8,
    gap: 12,
    width: '100%',
}); });
var IconWrapper = styled(Box)(function () { return ({
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: baseColors.greyPreset[55],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& svg, & span': {
        fontSize: 20,
        color: baseColors.darkPreset[10],
    },
}); });
var Badge = styled(Stack)(function () { return ({
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    borderRadius: 6,
    padding: '4px 6px',
    flexShrink: 0,
    '& svg, & span': {
        fontSize: 12,
    },
}); });
var BadgeTooltip = styled(function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement(Tooltip, __assign({}, props, { arrow: true, classes: { popper: className }, placement: "top" })));
})(function () {
    var _a;
    return (_a = {},
        _a["& .".concat(tooltipClasses.tooltip)] = {
            backgroundColor: baseColors.bluePreset[10],
            color: baseColors.fullWhite,
            borderRadius: 8,
            boxShadow: '0 10px 24px rgba(0,0,0,0.24)',
            padding: '14px 18px',
            minWidth: 250,
        },
        _a["& .".concat(tooltipClasses.arrow)] = {
            color: baseColors.bluePreset[10],
        },
        _a);
});
var CommonCardView = function (_a) {
    var icon = _a.icon, label = _a.label, value = _a.value, resolvedValue = _a.resolvedValue, badge = _a.badge, tooltip = _a.tooltip, mainResp = _a.mainResp;
    var displayValue = Array.isArray(mainResp)
        ? mainResp.find(function (item) { return (item === null || item === void 0 ? void 0 : item.IsPrimary) === 1 || (item === null || item === void 0 ? void 0 : item.IsPrimary) === '1'; })
        : null;
    var fallbackResolvedValue = displayValue && value ? displayValue === null || displayValue === void 0 ? void 0 : displayValue[value] : undefined;
    var displayText = resolvedValue || fallbackResolvedValue || value || '---';
    return (React.createElement(CardRoot, null,
        React.createElement(Stack, { direction: "row", alignItems: "center", gap: 1.5, sx: { minWidth: 0, flex: 1, overflow: 'hidden' } },
            icon && React.createElement(IconWrapper, null, icon),
            React.createElement(Stack, { gap: 0.5, sx: { minWidth: 0, overflow: 'hidden' } },
                label && (React.createElement(Typography, { variant: "caption", color: baseColors.greyPreset[30], noWrap: true }, label)),
                React.createElement(Tooltip, { title: displayText !== '---' ? displayText : '', placement: "top", arrow: true, disableInteractive: true },
                    React.createElement(Typography, { variant: "body2", fontWeight: 500, color: baseColors.greyPreset[10], noWrap: true, sx: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, displayText)))),
        badge && tooltip ? (React.createElement(BadgeTooltip, { title: tooltip },
            React.createElement(Badge, { sx: {
                    backgroundColor: baseColors.greyPreset[55],
                    border: "1px solid ".concat(baseColors.greyPreset[40]),
                    '& span': { color: "".concat(badge.color || baseColors.errorPreset[10]) },
                } },
                badge.icon,
                React.createElement(Typography, { variant: "caption", fontWeight: 500, sx: { color: "".concat(badge.labelColor || baseColors.errorPreset[20], " !important") } }, badge.label)))) : badge ? (React.createElement(Badge, { sx: {
                backgroundColor: baseColors.greyPreset[55],
                border: "1px solid ".concat(baseColors.greyPreset[40]),
                '& span': { color: "".concat(badge.color || baseColors.errorPreset[10]) },
            } },
            badge.icon,
            React.createElement(Typography, { variant: "caption", fontWeight: 500, sx: { color: "".concat(badge.labelColor || baseColors.errorPreset[20], " !important") } }, badge.label))) : null));
};
export default CommonCardView;
